import loginReducer from './authDetails';
import merchantReducer from './merchantSlice';

export default {
  login: loginReducer,
  merchant: merchantReducer,
};
